import React from 'react';

import { 
  Label
} from './styles';

interface RadioButtomProps {
  id: string,
  name: string,
  label: string,
  checked?: boolean,
  defaultChecked?: boolean,
  value?: any,
  onChange?: (e?:any) => void
}

export const RadioButton: React.FC<RadioButtomProps> = ({
  id,
  name,
  label,
  value,
  checked,
  defaultChecked,
  onChange
}) => {
  return (
    <Label htmlFor={id}>
      <input 
        type="radio" 
        id={id} 
        name={name} 
        checked={checked} 
        defaultChecked={defaultChecked}
        value={value} 
        onChange={onChange}
      />
      {label}
    </Label>
  );
}